import { CommonKeys } from "../../../common/enums";
import { STAMM_DYNFIELD_TYPE } from "../../interfaces/stammelements/StammElementDynField";

export const FormularGroupStammStammElementDynFieldSchema = {
    $id: "FormularGroupStammStammElementDynFieldSchema",
    title: "FormularGroupStammStammElementDynField Schema",
    type: "object",
    allOf: [
        { $ref: "FormularGroupStammStammElementBaseSchema" },
        {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: STAMM_DYNFIELD_TYPE },
                FieldID: { type: "number", nullable: true }
            }
        }
    ],
};
